import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loginRequest } from 'redux/action/login';
import { Route, BrowserRouter as Router, Switch, withRouter } from 'react-router-dom';
import AuthRoute from './components/session/AuthRoute';
import NotFound from './components/error/NotFound';

import Login from './components/login/Login';
import Main from './components/main/Main';

import Checker from './Checker';

import './App.css';

const App = () => {
  const dispatch = useDispatch();
  dispatch(loginRequest());
  dispatch({ type: 'BOARD_COLUMN_INIT' });

  useEffect(() => {
    window.localStorage.setItem('applicationStatus', '{ "alarm": "0", "status": "blue" }');
  }, []);

  return (
    <Router>
      <div className="App">
        <Switch>
          <AuthRoute exact path="/" render={(props) => <Main {...props} />} />
          <Route path="/login" render={(props) => <Login {...props} />} />
          <AuthRoute path="/:type" render={(props) => <Main {...props} />} />
          <Route render={NotFound} />
        </Switch>
        <Checker />
      </div>
    </Router>
  );
};

export default withRouter(App);
